"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceCache = void 0;
const node_cache_1 = __importDefault(require("node-cache"));
class ServiceCache {
    constructor(config) {
        this.config = config;
        this.cacheList = {};
    }
    createAll() {
        for (const [name, options] of Object.entries(this.config.cache)) {
            const cache = new node_cache_1.default(options);
            this.cacheList[name] = cache;
        }
        return Object.assign({}, this.cacheList);
    }
    resetAll() {
        const caches = Object.values(this.cacheList);
        caches.forEach((cache) => cache.flushAll());
        const isCacheReset = caches.every((cache) => cache.keys().length === 0);
        if (!isCacheReset) {
            return false;
        }
        return isCacheReset;
    }
}
exports.ServiceCache = ServiceCache;
//# sourceMappingURL=ServiceCache.js.map